import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form-custom step0-working-mode col-lg-6" }
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = { class: "p-field-label" }
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = { class: "p-field-radiobutton" }
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "fs-13" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.TypeOfObject")), 1),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.typeOptions, (type) => {
        return (_openBlock(), _createBlock("div", {
          key: `option-${type}`
        }, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_RadioButton, {
              id: `option-${type}`,
              name: "option",
              value: type,
              modelValue: _ctx.roomObject.actuatorModalityType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.roomObject.actuatorModalityType = $event))
            }, null, 8, ["id", "value", "modelValue"]),
            _createVNode("label", {
              for: `option-${type}`
            }, [
              _createTextVNode(_toDisplayString(_ctx.getOptionName(type)) + " ", 1),
              _hoisted_6,
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.getOptionDescription(type)), 1)
            ], 8, ["for"])
          ])
        ]))
      }), 128))
    ])
  ]))
}